import { PageTemplateView } from "@loot-os/design-system/templates/shared/PageTemplateView";
import { Navigate } from "@tanstack/react-router";

import { useShopper } from "../lib/shopper.js";
import { useTenant } from "../lib/tenant.js";
import { useForgeMineContent } from "../templates/pages/forge/useForgeMineContent.js";
import { storefrontTemplateOf } from "../templates/registry.js";

/** GET /v1/me/forge: the shopper's own forge boxes, what they have earned, and the claim. */
export function ForgeMinePage() {
  const { user, authPending } = useShopper();
  const { config } = useTenant();
  const content = useForgeMineContent();
  if (!authPending && !user) return <Navigate to="/login" replace />;
  return <PageTemplateView template={storefrontTemplateOf(config).forgeMine} content={content} />;
}
